export default "__VITE_ASSET__$gt1P5jU__"